"use client"

import { Info } from "lucide-react"
import { useTranslations } from "next-intl"
import { VOICE_KNOWLEDGE_PENDING_MESSAGE, VOICE_SETUP_PENDING_MESSAGE } from "@/lib/voice/elevenlabs-sync/status"

export function VoiceAgentSyncNotice({ message }: { message?: string | null }) {
  const t = useTranslations("Voice.AgentsVoiceVoiceAgentsPage")
  if (!message) return null
  let text: string
  switch (message) {
    case VOICE_KNOWLEDGE_PENDING_MESSAGE:
      text = t("knowledgePreparing")
      break
    case VOICE_SETUP_PENDING_MESSAGE:
      text = t("voicePreparing")
      break
    default:
      return <div role="alert" className="rounded bg-red-50 p-2 text-sm text-red-600"><span key={message}>{message}</span></div>
  }
  return (
    <div role="status" className="flex items-start gap-2 rounded bg-blue-50 p-2 text-sm text-blue-800">
      <Info aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0" />
      <span key={text} className="min-w-0">{text}</span>
    </div>
  )
}
